import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory, useParams } from 'react-router';
import { color } from '../../app/theme';
import Name from './Name';
import TripDate from './Time';
import Platform from './Platform';
import FacebookTag from './FacebookTag';
import TripNum from './TripNum';
import MessageNum from './MessageNum';
import Sleep from './Sleep';
import Button from '../shared/Button';

const useStyles = makeStyles(
  {
    root: {
      width: '100%',
      height: '100%',
      background: color.$7,
      padding: 44,
    },
    title: {
      fontSize: '20px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.3',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: 36,
    },
    next: {
      margin: '44px 0',
    },
  },
  {
    name: 'Container',
  },
);

const mainContainer = () => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const { orgId, procedureId } = useParams();

  const handleNext = () => {
    history.push(`/${orgId}/${procedureId}/rule`);
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('setting.title')}</div>
      <Name />
      <TripDate />
      <Platform />
      <FacebookTag />
      <TripNum />
      <MessageNum />
      <Sleep />
      <Button
        className={classes.next}
        topic="primaryGreen"
        onClick={handleNext}
      >
        {t('setting.next')}
      </Button>
    </div>
  );
};

export default mainContainer;
